import { useAdvanceSearchContext } from "../AdvanceSearchContext";
import { BetweenDates } from "../Betweendates";

export default function AdvanceSearchBetweenDates() {
  const { searchObject, setSearchObject, t } = useAdvanceSearchContext();

  return (
    <>
      <fieldset>
        <legend>{t("Between Dates")}</legend>
        <BetweenDates
          setObeject={setSearchObject}
          dateObject={searchObject}
          dateEndField="endingDate"
          dateStartField="startingDate"
        />
      </fieldset>
    </>
  );
}
